import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import {
    map,
    filter,
    pairwise,
    startWith,
    debounceTime,
    distinctUntilChanged,
} from 'rxjs/operators';
import { combineLatest, Observable } from 'rxjs';

import { CartState } from '../../cart/store/reducers/cart.reducer';
import { getCartTotalPrice } from '../../cart/store/selectors/cart.selectors';

@Injectable()
export class ZeroPaymentCheckingService {

  public showZeroPaymentFlow$: Observable<boolean>;

  constructor(private _cartStore: Store<CartState>) { }

  public subscribeToChanges() {
      const fromToZeroChanged$ = this._cartStore.select(getCartTotalPrice)
          .pipe(
            distinctUntilChanged(),
            pairwise(), // Compare [previous, current] values
            filter(([prev, current]) =>
                (prev > 0 && current === 0) || // Transition to zero
                (prev === 0 && current > 0)  // Transition from zero
            ),
            map(([prev, current]) => {
                return current !== null && current !== undefined && current === 0;
            })
        );

      this.showZeroPaymentFlow$ = combineLatest([
          this._cartStore.select(getCartTotalPrice).pipe(
              startWith(0),
          ),
          fromToZeroChanged$.pipe(
              startWith(false),
          )]
      ).pipe(
          debounceTime(100),  // Ensures emissions happen after the current task
          map(([totalPrice, isZero]) => {
              return (totalPrice !== null && totalPrice !== undefined && totalPrice <= 0) || isZero;
          }),
      );
  }
}
